import {Component, OnInit} from '@angular/core';
import {AttributesApiService} from '../../services/api/users/attributes/attributes-api.service';
import {DeviceLocationApiService} from '../../services/api/users/device-location/device-location-api.service';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {RoleTypeEnum} from '../../services/enums/role-type.enum';

@Component({
  selector: 'device-location',
  templateUrl: './device-location.component.html',
  styleUrls: ['./device-location.component.scss']
})
export class DeviceLocationComponent implements OnInit {

  isUnauthorized: boolean;
  attributesOptions;
  matchingPropertyIdOptions;
  locationPropertyIdOptions;
  deviceLocation: any = {};

  ovocMatchingProp = 'phoneNumber';
  ovocLocationProp = 'locationMatch';

  constructor(private deviceLocationApiService: DeviceLocationApiService,
              private attributesApiService: AttributesApiService,
              private userPrivilege: UserPrivilegeService, private loaderService: LoaderService) {
  }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized(RoleTypeEnum.USER_MANAGEMENT);
    this.initialDeviceLocationData();
  }

  updateAttributesOptions(): void {
    this.matchingPropertyIdOptions = this.attributesOptions.filter(attributes => attributes.id !== this.deviceLocation.locationPropertyId);
    this.locationPropertyIdOptions = this.attributesOptions.filter(attributes => attributes.id !== this.deviceLocation.matchingPropertyId);
  }

  onSubmit(): void {
    this.deviceLocationApiService.updateDeviceLocation(this.deviceLocation).subscribe(() => {
    });
  }

  private initialDeviceLocationData(): void {
    this.loaderService.showMainContainer();
    Promise.all([
      this.attributesApiService.getAttributes(),
      this.deviceLocationApiService.getDeviceLocation().toPromise()
    ]).then(results => {
      this.attributesOptions = results[0].filter(attribute => !attribute.isCombined)
        .map(attribute => {
          return {
            name: attribute.name,
            id: attribute.id
          };
        });
      this.deviceLocation = results[1];
      this.updateAttributesOptions();
      this.loaderService.hideMainContainer();
    }).catch((error) => {
      this.loaderService.hideMainContainer();
    });
  }

}
